import { invalidPhoneNumberMessage, phoneNumberValidationMessage } from '../constants';

export const phoneNumberPattern = /^\d{10}$/;

const isAllSameDigits = (digits: string): boolean => digits.length > 0 && /^(\d)\1+$/.test(digits);

const isSequential = (digits: string): boolean => digits.includes('123456789') || digits.includes('987654321');

const hasInvalidAreaCode = (digits: string): boolean => {
  if (digits.length < 3) return false;

  const areaCode = parseInt(digits.slice(0, 3), 10);

  return !Number.isNaN(areaCode) && areaCode <= 200;
};

const phoneNumberValidate = {
  notAllSameDigits: (phone: string | undefined): true | string => !isAllSameDigits(phone ?? '') || invalidPhoneNumberMessage,
  notSequential: (phone: string | undefined): true | string => !isSequential(phone ?? '') || invalidPhoneNumberMessage,
  validAreaCode: (phone: string | undefined): true | string => !hasInvalidAreaCode(phone ?? '') || invalidPhoneNumberMessage,
};

export const phoneNumberRules = (message = phoneNumberValidationMessage) => ({
  pattern: {
    message,
    value: phoneNumberPattern,
  },
  required: message,
  validate: phoneNumberValidate,
});
